import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'paymentForm.details.heading',
		defaultMessage: 'Payment details',
		description: 'Heading for payment form',
	},
	modalCta: {
		id: 'paymentForm.details.cta',
		defaultMessage: 'Why now?',
		description: 'Text for payment modal cta',
	},
	modalTitle: {
		id: 'paymentForm.details.modalTitle',
		defaultMessage: 'Payment details',
		description: 'Title for payment modal CTA',
	},
	buttonCta: {
		id: 'paymentForm.purchaseForm.cta',
		defaultMessage: 'Start Free Trial',
		description: 'Cta for the submit payment form button',
	},
	trial: {
		id: 'dodo.paymentDetails.modal.trialInfo',
		defaultMessage:
			'We ask for your payment information now so you can enjoy Calm uninterrupted after your 30-day trial ends.',
		description: 'Trial info in payment details modal',
	},
	cancel: {
		id: 'dodo.paymentDetails.modal.cancelInfo',
		defaultMessage: "If you cancel anytime before the end of the 30-day trial, you won't be charged.",
		description: 'Cancellation info in payment details modal',
	},
	confirmButtonCta: {
		id: 'dodo.paymentDetails.modal.buttonCta',
		defaultMessage: 'Got it',
		description: 'Button cta to close the modal',
	},
});
